import * as nativeApp from 'utils/nativeApp'
import React from 'react'
import useTranslation from 'hooks/useTranslation'

interface ShareButtonProps {
  title: string
  text: string
  url: string
  active: boolean
}

const ShareButton: React.FC<ShareButtonProps> = ({ title, text, url, active }) => {
  const { t } = useTranslation('profile')
  const handleShare = async () => {
    if (nativeApp.isAndroid()) {
      nativeApp.shareOnAndroid({ title, text, url })

    } else if (navigator.share) {
      try {
        await navigator.share({
          title,
          text,
          url
        })
      } catch (error) {
        console.error('Błąd udostępniania', error)
      }

    } else {
      alert('Niestety ta funkcja nie jest wspierana w Twojej przeglądarce. Skopiuj link z paska adresu i prześlij dalej.')
    }
  }

  return (
    <div className='wrap' onClick={handleShare}>
      <span className={`${active ? 'active' : ''}`}>
        {t('share')}
      </span>
      <i className="icon icon--share"></i>
    </div>
  )
}

export default ShareButton
